<template>
  <div class="advantagesCheckin">
    <div class="advantagesCheckin__content">
      <h2 class="advantagesCheckin__title">Deixe tudo preparado antes do atendimento!</h2>
      <p class="advantagesCheckin__text">
        Selecione seus exames agora e conclua o<br />
        pagamento na recepção da unidade.
      </p>
      <div class="advantagesCheckin__iconGroup">
        <div class="advantagesCheckin__iconGroup--icon">
          <CircleIconAddSvg />
          <p>Adicione seus exames</p>
        </div>
        <div class="advantagesCheckin__dashedLine"></div>
        <div class="advantagesCheckin__iconGroup--icon">
          <CircleIconPaymentsSvg />
          <p>Pague na recepção</p>
        </div>
        <div class="advantagesCheckin__dashedLine"></div>
        <div class="advantagesCheckin__iconGroup--icon">
          <CircleIconLabExamSvg />
          <p>Faça coleta ou vacina</p>
        </div>
      </div>
    </div>
    <div class="advantagesCheckin__buttons">
      <VButton text="Selecionar exames ou vacinas" variant="primary" @click.native="addExams()" />
      <VButton text="Continuar sem selecionar" variant="secondary" @click.native="withoutExams()" />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { dataLayersMixin } from '@/utils/mixins';

export default {
  mixins: [dataLayersMixin],
  mounted() {
    this.mostCommonPagesAnalytics({
      step: 'seleção_de_serviços',
      screen: 'seleção_de_facilidade',
      complementaryObject: {
        previous_choice: '2 ou menos',
      },
      payment: {
        type: 'particular',
      },
    });
  },
  methods: {
    ...mapActions({
      setAdmissionNotElegible: 'setAdmissionNotElegible',
      checkAndSetT2Flow: 'checkAndSetT2Flow',
    }),
    async addExams() {
      await this.checkAndSetT2Flow();
      return this.goNextStep('search_exams');
    },
    async withoutExams() {
      await this.setAdmissionNotElegible();
      return this.goNextStep('exams_add', {
        previous_choice: 'Continuar sem selecionar',
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.advantagesCheckin {
  display: flex;
  flex-direction: column;
  align-items: center;

  &__content {
    flex: 1;
  }

  &__title {
    font-weight: 600;
    font-size: 20px;
    margin-top: 30px;
    margin-bottom: 3px;
    color: #161616;
    letter-spacing: -1px;
  }

  &__text {
    font-weight: 600;
    font-size: 14px;
    color: #363636;
    letter-spacing: -0.7px;
  }

  &__iconGroup {
    display: flex;
    margin-top: 40px;

    &--icon {
      width: 30%;
    }

    p {
      font-size: 14px;
    }
  }

  &__dashedLine {
    display: flex;
    height: 60px;
    div {
      width: 30px;
      border-bottom: 1px dashed #363636;
      align-self: center;
    }
  }

  &__buttons {
    button {
      margin-bottom: 16px;
      max-width: 320px;

      &:nth-child(2) {
        background-color: transparent;
        color: var(--color-primary);
        border-color: transparent;
      }
    }
  }
}
</style>
